import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AddressService {
  private direccionActualizadaSource = new Subject<void>();

  direccionActualizada$ = this.direccionActualizadaSource.asObservable();

  emitirActualizacion() {
    this.direccionActualizadaSource.next();
  }
}
